import {useUserContext} from '@containers/App/UserProvider'
import type {UserContextProps} from '@containers/App/UserProvider'

/**
 * Whether the current user is a platform "read-only admin": a staff user with no
 * real management capability in the current organization. Such users may VIEW
 * admin areas, but every create/edit/delete control must be hidden or disabled.
 *
 * The determination is made on the backend (the tenants service computes the
 * `is_read_only_admin` capability alongside `is_account_admin`, `can_manage_*`,
 * etc.) so the UI never sees the raw `is_staff`/`is_superuser` flags. It is
 * `false` for superusers and for a staff user who also holds a real capability —
 * they keep their normal edit rights, mirroring the backend.
 */
export const useIsReadOnly = (): boolean => {
  // Tolerate a missing UserProvider (e.g. the public Alpinist demo embed renders a minimal
  // provider stack) — same guard as useServiceCapabilities.
  const {currentUser} = (useUserContext() as UserContextProps | null) ?? {currentUser: null}
  return currentUser?.userprofile?.is_read_only_admin === true
}
